'use client'

import { DocumentsList } from '../DocumentsList'

import { Page } from '@/shared/ui/Page'

export function LibraryListPage() {
  return (
    <Page variant="purple">
      <DocumentsList />
    </Page>
  )
}
